import { Box } from '../../components/UI-CHAKRA/Box';
import { Text } from '../../components/UI-CHAKRA/Text';

import { isRunningInIframe } from '../../helpers/isRunningInIframe';
import { sendCancelPostMessage } from '../../helpers/window';

import { ReactComponent as Logo } from '../../assets/images/icons/mevo/powered_mevo.svg';
import { Button } from '../../components/UI-CHAKRA/Button';

export default function NotFound() {
  const isRunningOnIframe = isRunningInIframe();

  return (
    <Box
      width={'100%'}
      height={'100%'}
      bg={'gray.lightest'}
      color={'white'}
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      flexDirection={'column'}
    >
      <Box h={'80px'} bg={'#fff'} w={'100%'}></Box>

      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
        <Text
          lineHeight={{ base: '140px', md: '200px' }}
          fontFamily={'Ambit-Regular'}
          fontSize={{ base: '120px', md: '200px' }}
          fontWeight={700}
          color={'primary.main'}
        >
          404
        </Text>

        <Text
          fontFamily={'Ambit-Regular'}
          fontSize={{ base: '16px', md: '28px' }}
          fontWeight={600}
          color={'primary.main'}
        >
          Ops.. Parece que não há nada aqui!
        </Text>

        {isRunningOnIframe && (
          <Button
            variant={'ghost'}
            color={'primary.main'}
            borderRadius={'20px'}
            w={'192px'}
            mt={'20px'}
            boxShadow={'3px 3px 10px rgba(61, 14, 107, 0.1)'}
            _hover={{
              background: '#fff8f9',
              color: 'primary.secondary',
            }}
            onClick={sendCancelPostMessage}
          >
            Voltar ao início
          </Button>
        )}
      </Box>

      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} h={'80px'} bg={'#fff'} w={'100%'}>
        <Logo />
      </Box>
    </Box>
  );
}
